import * as React from 'react';
import { ConfigValuesProvider } from './common/contexts/ConfigValues/ConfigValuesProvider';
import { Router } from './Router';
import { Themed } from '@sky-distribution/react-commons-ui';
import { AppStyled, CommonStyle } from './common/styles/CommonStyle';
import { getConfigValuesFromEnv } from './utils';
import { AppConfigValues } from './common/types';
import { useTheme } from './config/utils/useTheme';

export const App: React.FC = () => {
  const [configValues, setConfigValues] = React.useState<AppConfigValues | null>(null);
  const theme = useTheme();

  React.useEffect(() => {
    getConfigValuesFromEnv().then((data) => {
      setConfigValues(data);
    });
  }, []);

  return (
    <Themed theme={theme}>
      <AppStyled>
        <CommonStyle />
        {configValues && (
          <ConfigValuesProvider configValues={configValues}>
            <Router />
          </ConfigValuesProvider>
        )}
      </AppStyled>
    </Themed>
  );
};
